import { findActiveStoreView, getStoreViews } from '@emico/storeviews'

export function stripDomainFromUrl(to: string) {
  const activeStoreView = findActiveStoreView(getStoreViews())
  const toPath = to.replace(activeStoreView?.makeUrl('/') ?? '', '/')

  return toPath
}
